<script lang="ts">
	import { beforeUpdate, onMount } from "svelte";
	import { APP_VERSION } from './scripts/constant';
	import { redirection, setBackendUrl } from "./scripts/common";
	import Route from "./components/Route.svelte";
	import PodcastPlayer from "./components/PodcastPlayer.svelte";
    import Menu from "./components/Menu.svelte";
    import { storePodcasts } from './scripts/classes/podcast';
    import { getPodcasts } from './scripts/api/apiPodcasts';
	import { storeCurRoute, routes } from './scripts/router1';
    import { idPageAPropos, idPagePodcast } from "./scripts/router2";

	export let name: string;
	let wave_hidden: boolean = false;
	
	beforeUpdate(() => {
		setBackendUrl();
	})

	onMount(async () => {
		console.log(APP_VERSION.name + " - version " + APP_VERSION.version);
		getPodcastsIfEmpty()
		redirection();
		isWaveToDisplay();
	});

    function getPodcastsIfEmpty() {
        if ($storePodcasts.length <= 0) {
            getPodcasts();
        }
    }

	function isWaveToDisplay() {
		storeCurRoute.subscribe((data) => {
			if (data == idPagePodcast || data == idPageAPropos) {
				wave_hidden = true;
			} else {
				wave_hidden = false;
			}
        });
	}

</script>

<style lang="scss">

	.main {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0;
        padding: 0;
		width: 100%;
        min-height: 100vh;
		background-color: $color-primary;
		overflow: hidden;
		&__wave {
			margin: -10px 0 0 0;
			width: 120%;
			min-height: 200px;
			background-image: url('../assets/images/stacked-waves-haikei.svg');
			background-position: center;
			background-repeat: repeat;
			background-size: cover;
			color: $color-secondary;
			background-color: $color-secondary;
			opacity: 1;
			animation-name: moveLogo;
			animation-duration: 20s;
			animation-delay: 0s;
			animation-iteration-count: infinite;
			animation-direction: initial;
			animation-timing-function: linear;
			z-index: 50;
			transform: translateX(-50px);
			&__hidden {
				display: none;
			}
		}
        &__route {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            background-color: $color-primary;
			overflow-y: scroll;
			overflow-x: hidden;
        }

        &__menu {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
            background-color: $color-secondary;
        }
		&__anchor {
			scroll-margin-top: 100px;
			background-color: $color-secondary;
			width: 100%;
			height: 1px;
			display: none;
		}
	}

	@include large {
		.main {
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			margin: 0;
			padding: 0;
			min-height: 100vh;
			background-color: $color-primary;
			overflow: hidden;
			&__wave {
				margin: 0 0 0 0;
			}
			&__route {
				z-index: 100;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				background-color: $color-primary;
				overflow-y: scroll;
				-ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
				scrollbar-width: none; /* Hide scrollbar for Firefox */
				&::-webkit-scrollbar {
					/* Hide scrollbar for Chrome, Safari and Opera */
					display: none;
            	}
			}
			&__menu {
				height: $height_menu;
				justify-content: flex-start;
				overflow-y: scroll;
				-ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
				scrollbar-width: none; /* Hide scrollbar for Firefox */
				&::-webkit-scrollbar {
					/* Hide scrollbar for Chrome, Safari and Opera */
					display: none;
				}
			}
			&__line {
				scroll-margin-top: 100px;
				background-color: $color-secondary;
				width: 100%;
				height: 1px;
			}
		}
	}

    @keyframes moveLogo {
        0% {
            transform: translateX(-50px);
        }
        20% {
            transform: translateX(-45px);
        }
        40% {
            transform: translateX(-15px);
        }
        50% {
            transform: translateX(-10px);
        }
        60% {
            transform: translateX(-15px);
        }
        80% {
            transform: translateX(-45px);
        }
        100% {
            transform: translateX(-50px);
        }
    }

</style>

<div class="main">
	<div class="main__menu">
		<Menu />
	</div>
	<div class="main__line"></div>
	<div id="id_main_route" class="main__route">
		<div id="anchor" class="main__anchor"></div>
		<div class="main__wave__hiden"></div>
		<Route />
		<PodcastPlayer />
	</div>
</div>